module.exports = __webpack_public_path__ + "assets/8f9dc0f31c881b33f039a2919e9dab2f.png";